import { render, staticRenderFns } from "./CustomerSelector.vue?vue&type=template&id=1d7edf79&scoped=true"
import script from "./CustomerSelector.vue?vue&type=script&lang=js"
export * from "./CustomerSelector.vue?vue&type=script&lang=js"
import style0 from "./CustomerSelector.vue?vue&type=style&index=0&id=1d7edf79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7edf79",
  null
  
)

export default component.exports